import IconButton from "components/atoms/button/IconButton";
import Form from "components/atoms/form/Form";
import { useDeleteSource } from "lib/hooks/mutations/Sources/useDeleteSource";

import { FC } from "react";
import { useTranslation } from "react-i18next";

export interface IDeleteSourceProps<T> {
  onConfirm: () => void;
  onCancel: () => void;
  id?: number;
  data: T;
  themeColors: {
    primary: string;
  };
}

const DeleteSource: FC<IDeleteSourceProps<any>> = ({
  onConfirm,
  onCancel,
  id,
  data,
  themeColors,
}) => {
  const { mutateAsync: DeleteSourceById, isLoading } = useDeleteSource();
  const { t } = useTranslation()

  const DeleteSource = () => {
    DeleteSourceById(id)
      .then(() => {
        onConfirm();
      })
      .catch(() => {});
  };
  return (
    <Form className="mb-0 flex flex-col gap-10">
      <div>
        <div className="text-[20px] font-inter-medium">
          {t('Are you sure you want to delete')}{" "}
          {data.name
            ? data.name.charAt(0).toUpperCase() + data.name.slice(1)
            : "Not available"}{" "}
        </div>
      </div>
      <div className="flex gap-5 justify-end">
        <div>
          <IconButton
            secondary={true}
            onClick={() => {
              onCancel();
            }}
            type="button"
            className={`!text-[${themeColors.primary}]`}
          >
            {t('Cancel')}
          </IconButton>
        </div>
        <div>
          <IconButton
            onClick={DeleteSource}
            type="button"
            disabled={isLoading}
            className={`bg-[${themeColors.primary}] border-[${themeColors.primary}]`}
          >
            {t('Delete')}
          </IconButton>
        </div>
      </div>
    </Form>
  );
};

export default DeleteSource;
